import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PhcAppMenu, PhcAppMenuItem, PhcLink } from '../../classes/phc-app/phc-app';
import { WpProvider } from '../wp/wp';

import KeenTracking from 'keen-tracking';

/*
  Generated class for the AnalyticsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnalyticsProvider {

  subdomain = '';
  client = new KeenTracking({
    projectId: '5bcf8ea0c9e77c00018f5157',
    writeKey: '72D6BFE4456A20B07FE1972E659DE913193AEBDC71476FB92DB8F89B7BBE2F06F55A6DEFB730799BB47F701126DF96A8D84BB84C24FB7C191509B438EE6460A800885CBFFD8810CFDA74F9BD3669FDFCFF9123523B39AC8DF66996AE59894977'
  });

  constructor(public http: HttpClient, private wp: WpProvider) {
    console.log('Hello AnalyticsProvider Provider');
    this.subdomain = wp.app.planaday_subdomain;
  }

  trackItem(item: PhcAppMenuItem | PhcAppMenu) {
    if (item) {
      const body = {
        page: item.title,
        url: this.subdomain,
        keen: {
          addons: [
            {
              name: 'keen:date_time_parser',
              input: {
                date_time: 'keen.timestamp',
              },
              output: 'timestamp_info',
            },
          ],
        },
      };
      this.client.recordEvent('clicks', body);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts